import * as React from 'react'
import { PageSpinnerWidgetConnected } from './PageSpinnerWidgetConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const PageSpinnerWidgetExamples = () => {
  return (
    <div className="PageSpinnerWidgetExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <PageSpinnerWidgetConnected />
      </Provider>
    </div>
  )
}
